/// <amd-module name="typeahead/features/SuggestionIconSuppressor" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../typings/typeahead/suggestionsProvider.d.ts"/>

import {SuggestionRendererUtils} from "typeahead/core/presentation/SuggestionRendererUtils";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {IEssSuggestionResult, ISuggestionResult} from "typeahead/core/Suggestion";
import {SuggestionModifier} from "typeahead/core/SuggestionModifier";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

export class SuggestionIconSuppressor extends SuggestionModifier {
    private static readonly inapplicableClients: string[] = [];

    protected configuration: IStripingConfiguration[] = [{
        lobs: ["FLIGHTS"],
    }, {
        clients: ["Flights.Search"],
    }];
    protected featureName: string = "SuppressIcon";

    protected modify(suggestions: ISuggestionResult[], context: IContext) {
        suggestions.forEach((sugg: ISuggestionResult): void => {
            if (!SuggestionRendererUtils.isConsistentDisplay(sugg)
                && sugg.type !== "LIST" && !TypeaheadUtils.isChildSuggestion(sugg as IEssSuggestionResult)) {
                sugg.icon = "none";
            }
        });
    }

    protected precondition(suggestions: any, context: IContext) {
        return super.precondition(suggestions, context) &&
            SuggestionIconSuppressor.inapplicableClients.lastIndexOf(context.clientId) < 0;
    }

    // This feature is turned on in general. It is turned off off for specific client(s) to assist an investigation.
    // For details of that investigation, see:
    // https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/4368
    //
    // Should opting out of features becomes permenantly useful, it should be implemented through the suggestionPicker
    // tag. The task is tracked with https://eiwork.mingle.thoughtworks.com/projects/ewe_discovery_services/cards/4192 .
}
